import React, { useEffect, useState } from "react";
import {
  Box,
  Paper,
  Typography,
  Button,
  IconButton,
  Grid,
  Chip,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import ButtonTheme from "../../components/ThemeButton/ThemeButton";
import ApiService from "../../functions/apiService";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { Divider } from "@mui/material";
import { Col, Modal, Row } from "react-bootstrap";
import { toast } from "react-toastify";
import { CircularProgress } from "@mui/material";


const TemplateManagement = () => {
  const [template, setTemplate] = useState([])
  const [saving, setSaving] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [deleteModal, setDeleteModal] = useState(false);
  const [selectedTemplateId, setSelectedTemplateId] = useState(null);
  const [menu, setMenu] = useState([]);




  const fetchTemplateList = async () => {
    try {
      setLoading(true);
      const res = await ApiService.get('/template');
      setTemplate(res?.data?.data ?? []);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTemplateList();
  }, []);
  const loadDDL = () => {
    ApiService.get("/getOvertimeListsDDL").then(({ data }) => {
      setMenu(data);
    });
  };
  useEffect(() => {
    loadDDL();
  }, [])
  const menuArray = Object.entries(menu);
  const getMenuLabel = (key) => {
    return menuArray?.find(item => item[0] === key)?.[1] || key;
  };

  const deleteTemplate = async () => {
    try {
      setSaving(true);
      await ApiService.post(`/template/delete/${selectedTemplateId}`);
      toast.success("Template deleted successfully");
      setDeleteModal(false);
      fetchTemplateList();
    } catch (error) {
      toast.error(error?.response?.data?.message || "Delete failed");
    } finally {
      setSaving(false);
    }
  };
  if (loading) {
    return (
      <Box
        className="w-100 d-flex justify-content-center align-items-center mt-2"
        style={{ height: '510px' }}
      >
        <CircularProgress />
      </Box>
    );
  }
  
  return (
    <>{template.length === 0 ? (
      <Paper
        className="p-4"
        sx={{
          mt: 2,
          p: 3,
          fontFamily: 'karla',
          height: '90%'
        }}

      >
        <div className="mb-4">
           <Typography style={{ fontSize: '28px', fontWeight: '400', fontFamily: 'karla' }} >
            Template management
          </Typography>

          <Typography fontSize={14} color="text.secondary" mb={2} style={{ fontFamily: 'karla'  }} >
            There are no templates configured, please add them as needed.
          </Typography>
        </div>

        <div className='d-flex  align-items-center justify-content-center' style={{ height: '330px', width: '100%', border: '2px solid #EAECF0', marginTop: '16px', borderRadius: '8px' }}>
          <div style={{ display: 'flex', flexDirection: 'column' }} >
            <img src='/images/blur-logo.png' style={{ height: 159, width: 200 }} />
            {/* <span className='mt-4' style={{ color: '#555555' }}>
              No template Found
            </span> */}
            <ButtonTheme
              type='submit' variant="filled" color='primary' className='mt-4' fontFamily="karla"

              onClick={() => navigate("/firehouse/add-template")}
            >
              Add new template
            </ButtonTheme>
          </div>
        </div>

      </Paper>
    ) : (

      <div className="pt-4">
        <Paper
          elevation={2}
          sx={{
            p: 3,
            borderRadius: "8px",
            minHeight: "90vh",
            // border:"2px solid red",
          }}
        >
          {/* Header */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
              mb: 3
            }}
          >
            <Box>
                <Typography style={{ fontSize: '28px', fontWeight: '400', fontFamily: 'karla' }} >
                  Template management
                </Typography>
              <Typography fontSize="13px" color="text.secondary">
                Manage and add new templates
              </Typography>
            </Box>

            <ButtonTheme
              type='submit' variant="filled" color='primary' className=' mt-4' fontFamily="karla" onClick={() => navigate("/firehouse/add-template")}>
              Add new template
            </ButtonTheme>
          </Box>

          {/* Template Card */}

          <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
            {template.map((item) => (
              <Paper
                key={item.Id}
                elevation={0}
                sx={{
                  width: "100%",
                  maxWidth: "500px",
                  p: 2,
                  borderRadius: "12px",
                  border: "1px solid #E5E9EB",
                  backgroundColor: '#F8F9FA'
                }}
              >
                {/* Header */}
                <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
                  <Typography sx={{ fontSize: "18px", fontWeight: 500 }}>
                    {item.Name}
                  </Typography>
                  <Box sx={{ display: "flex", gap: 0.5 }}>
                    <IconButton size="small" sx={{ bgcolor: "#f5f5f5" }} onClick={() =>navigate(`/firehouse/template/update/${item.Id}`, {state: {list: [...new Set(item.positions.map(p => p.List))][0] }})}>
                      <EditIcon sx={{ fontSize: 18 }} />
                    </IconButton>
                    <IconButton size="small" sx={{ bgcolor: "#f5f5f5" }} onClick={() => {
                      setSelectedTemplateId(item.Id);
                      setDeleteModal(true);
                    }}>
                      <DeleteIcon sx={{ fontSize: 18 }} />
                    </IconButton>
                  </Box>
                </Box>
                <Divider sx={{ mb: 1, borderBottomWidth: 2, borderColor: "#CFCFCF" }} />
                {/* Details */}
                <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                  {/* Type */}
                  <Box sx={{ display: "flex" }}>
                    <Typography sx={{ fontSize: "14px", fontWeight: 500, minWidth: "140px" }}>
                      Type
                    </Typography>
                    <Typography sx={{ fontSize: "14px", ml: 2 }}>
                      {item?.Type?.charAt(0).toUpperCase() + item?.Type?.slice(1)}
                    </Typography>
                  </Box>

                  {/* Description */}
                  <Box sx={{ display: "flex" }}>
                    <Typography sx={{ fontSize: "14px", fontWeight: 500, minWidth: "140px" }}>
                      Description
                    </Typography>
                    <Typography sx={{ fontSize: "14px", ml: 2 }}>
                      {item.Description}
                    </Typography>
                  </Box>

                  {/* Position Req */}
                  <Box sx={{ display: "flex" }}>
                    <Typography sx={{ fontSize: "14px", fontWeight: 500, minWidth: "140px" }}>
                      Position Req
                    </Typography>
                    <Box sx={{ display: "flex", justifyContent: 'flex-start', flexWrap: 'wrap', alignItems: "center", gap: 1, ml: 2 }}>
                      {item?.positions?.filter((pos) => pos?.position_name !== null || pos?.Position_Id !== null)?.map((pos) => (
                        <Chip
                          key={pos.Id}
                          label={`${pos?.position_name !== null ?pos?.position_name: pos?.Position_Id}  x${pos.Quantity}`}
                          sx={{
                            bgcolor:'rgba(191, 29, 45, 0.1)',
                            // color: "#000",
                            fontSize: "13px",
                            height: "28px"
                          }}
                        />
                      ))}
                    </Box>
                  </Box>

                  {/* Ranking */}
                  <Box sx={{ display: "flex" }}>
                    <Typography sx={{ fontSize: "14px", fontWeight: 500, minWidth: "140px" }}>
                      Ranking
                    </Typography>
                    <Typography sx={{ fontSize: "14px", ml: 2 }}>
                      {item.Ranking_Order}
                    </Typography>
                  </Box>
                  <Box sx={{ display: "flex" }}>
                    <Typography sx={{ fontSize: "14px", fontWeight: 500, minWidth: "140px" }}>
                      List
                    </Typography>
                    <Typography sx={{ fontSize: "14px", ml: 2 }}>
                      <Typography sx={{ fontSize: "14px" }}>
                        {[...new Set(item.positions?.map(pos => pos.List))]
                          .map(listKey => getMenuLabel(listKey))
                          .join(", ")}
                      </Typography>
                    </Typography>
                  </Box>
                </Box>
              </Paper>
            ))}
          </Box>

        </Paper>
      </div>
    )}
      <Modal show={deleteModal} onHide={() => setDeleteModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Delete Template</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div style={{ color: '#555555' }}>
            Are you sure you want to delete this template?
          </div>

          <Row>
            <Col md="auto">
              <ButtonTheme
                variant="filled"
                color="white"
                className="mt-4"
                onClick={() => setDeleteModal(false)}
              >
                Cancel
              </ButtonTheme>
            </Col>

            <Col md="auto">
              <ButtonTheme
                variant="filled"
                color="primary"
                className="mt-4"
                disabled={saving}
                onClick={deleteTemplate}
              >
                Confirm
              </ButtonTheme>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>

    </>

  );
};

export default TemplateManagement;
